// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bhvsqiffenuabtwekgsj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJodnNxaWZmZW51YWJ0d2VrZ3NqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM2MDI1NjUsImV4cCI6MjA1OTE3ODU2NX0.UpXmxwqiZNgyDccaOlkKmcInLv4-RMi0JpqyGD55cFk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);